export default __webpack_public_path__ + "static/media/WRITING.50aa4f85.svg";